import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const VirtualTour = ({ slice }) => {
  return (
    <section className={`${slice.primary ? 'component-virtualTour mx-auto w-full max-w-6xl p-6 md:py-10 lg:py-16' : ''}`}>
      {slice.primary?.title.text !== null && (
        <div className='prose mx-auto text-center'>
          <PrismicRichText field={slice.primary?.title.richText} />
        </div>
      )}
      <div dangerouslySetInnerHTML={{ __html: slice.primary.url.html }} />
    </section>
  )
}

export default VirtualTour
